module.exports = __webpack_public_path__ + "static/media/gb-wls.9f7c50cf.svg";